import React, { useRef, useState } from 'react';
import { Box } from '@mui/material';
import { arrayMove } from '@dnd-kit/sortable';
import { generatePath, Route, Switch, useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import RoutesMap from './Components/RoutesMap';
import RoutesSidePanel from './Components/RoutesSidePanel';
import OverlayLoader from '../../components/OverlayLoader';
import routes from '../../routes';
import RoutesStopDetails from './RoutesStopDetails';

const mapStyles = { height: 'calc(100vh - 90px)', width: '100%', position: 'relative' };

const RoutesContainer = () => {
  const history = useHistory();
  const activeRoutesEntities = useSelector((state) => state.entities.routes);
  const activeRoutes = Object.values(activeRoutesEntities.byId);
  const [selectedRoutes, setSelectedRoutes] = useState([]);
  const [newRouteStep, setNewRouteStep] = useState(false);
  const [showDonors, setShowDonors] = useState(true);
  const [showReceivers, setShowReceivers] = useState(false);
  const [locations, setLocations] = useState([]);
  const [selectedLocations, setSelectedLocations] = useState([]);
  const [distanceAndDuration, setDistanceAndDuration] = useState({});
  const selectedLocationsRef = useRef([]);

  const stopsDefaultValues = selectedLocations.reduce(
    (acc, curr) => ({
      ...acc,
      [curr?.id]: { ...curr, pickup_begin: '08:00:00', pickup_end: '10:00:00', weight: '', categories: [] },
    }),
    {}
  );

  const handleRouteClick = (route) => setSelectedRoutes([route]);
  const handleNewRouteClick = () => setNewRouteStep(true);
  const handleCancelNewRoute = () => {
    setNewRouteStep(false);
    setSelectedLocations([]);
    setShowDonors(true);
    setShowReceivers(false);
    setSelectedRoutes([]);
  };
  const handleShowDonorsClick = () => {
    setShowReceivers(false);
    setShowDonors(true);
  };
  const handleShowReceiversClick = () => {
    setShowDonors(false);
    setShowReceivers(true);
  };

  const updateDistanceAndDuration = (data) => {
    setDistanceAndDuration(data);
  };

  const addLocation = (marker) => {
    setLocations((prev) => [...prev, marker]);
  };

  const handleLocationSelect = (loc) => {
    const locationSelected = selectedLocationsRef.current.find((l) => l.id === loc.id);
    if (locationSelected) {
      return;
    }

    selectedLocationsRef.current = [...selectedLocations, loc];
    setSelectedLocations((prev) => [...prev, loc]);
  };

  const handleLocationRemove = (loc) => {
    const newLocations = selectedLocations.filter((l) => l.id !== loc.id);
    setSelectedLocations(newLocations);
    selectedLocationsRef.current = newLocations;
  };

  const handleLocationDrag = (event) => {
    const { active, over } = event;
    if (!over || active.id === over.id) {
      return;
    }

    setSelectedLocations((prev) => {
      const oldIndex = prev.findIndex((item) => item.id === active.id);
      const newIndex = prev.findIndex((item) => item.id === over.id);
      return arrayMove(prev, oldIndex, newIndex);
    });
  };

  const handleProceedToStopDetails = () => {
    history.push(generatePath(routes.routes, { tab: 'add' }));
  };

  return (
    <OverlayLoader isLoading={null}>
      <Box sx={{ display: 'flex' }}>
        <Switch>
          <Route
            exact
            path={generatePath(routes.routes)}
            render={() => (
              <>
                <RoutesSidePanel
                  routes={activeRoutes}
                  handleRouteClick={handleRouteClick}
                  handleNewRouteClick={handleNewRouteClick}
                  handleCancelNewRoute={handleCancelNewRoute}
                  newRouteStep={newRouteStep}
                  showDonors={showDonors}
                  showReceivers={showReceivers}
                  handleShowDonorsClick={handleShowDonorsClick}
                  handleShowReceiversClick={handleShowReceiversClick}
                  locations={locations}
                  selectedLocations={selectedLocations}
                  handleLocationSelect={handleLocationSelect}
                  handleLocationRemove={handleLocationRemove}
                  handleLocationDrag={handleLocationDrag}
                  onContinueClick={handleProceedToStopDetails}
                />
                <RoutesMap
                  routes={selectedRoutes.length ? selectedRoutes : activeRoutes}
                  allRoutes={activeRoutes}
                  newRouteStep={newRouteStep}
                  showDonors={showDonors}
                  showReceivers={showReceivers}
                  locations={locations}
                  addLocation={addLocation}
                  selectedLocations={selectedLocations}
                  handleLocationSelect={handleLocationSelect}
                  styles={mapStyles}
                  updateDistanceAndDuration={updateDistanceAndDuration}
                />
              </>
            )}
          />
          <Route
            exact
            path={generatePath(routes.routes, { tab: 'add' })}
            render={() => (
              <RoutesStopDetails
                stops={selectedLocations}
                defaultValues={stopsDefaultValues}
                handleCancelNewRoute={handleCancelNewRoute}
                distanceAndDuration={distanceAndDuration}
              />
            )}
          />
        </Switch>
      </Box>
    </OverlayLoader>
  );
};

export default RoutesContainer;
